/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-webpack-loader-syntax */
// @ts-ignore
import styles from '!!css-loader!sass-loader!./Synk.style.scss';
import { BoxExportDataTypes } from '../../boxTypes';
import component, { templateName, templateID, colors } from './Synk';

const simpleComparisionData: BoxExportDataTypes = {
  templateID,
  name: templateName,
  component,
  styles,
  config: { colors },
};

export default simpleComparisionData;
